import distributorService from '../../services/distributorService';

const openStatuses = ['submitted', 'approved', 'shipped'];
const unwrap = (response) => response?.data?.data;
const calendarDay = (value) => {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(value)) return null;
  const parsed = new Date(value);
  return Number.isFinite(parsed.getTime()) &&
    parsed.toISOString().slice(0, 10) === value.slice(0, 10)
    ? value.slice(0, 10)
    : null;
};

// Search every open-order page, not just the newest orders: an older submission can be due next.
// A changing or oversized result fails visibly rather than presenting a partial list as complete.
export async function upcomingDeliveries(signal, now = new Date()) {
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const groups = await Promise.all(
    openStatuses.map(async (status) => {
      const rows = [],
        ids = new Set();
      let total;
      for (let page = 1; page <= 100; page += 1) {
        if (signal.aborted) throw new Error('Cancelled overview');
        const value = unwrap(
          await distributorService.listOrders(page, status, undefined, { signal })
        );
        if (
          !Array.isArray(value?.data) ||
          !Number.isSafeInteger(value.total) ||
          value.total < 0 ||
          value.data.length !== Math.min(20, Math.max(0, value.total - (page - 1) * 20)) ||
          (total !== undefined && total !== value.total)
        )
          throw new Error('Invalid deliveries');
        total = value.total;
        for (const row of value.data) {
          if (
            typeof row?._id !== 'string' ||
            !row._id ||
            ids.has(row._id) ||
            typeof row.orderId !== 'string' ||
            !row.orderId ||
            row.status !== status ||
            (row.deliveryDate != null && !calendarDay(row.deliveryDate))
          )
            throw new Error('Invalid delivery');
          ids.add(row._id);
          if (row.deliveryDate && calendarDay(row.deliveryDate) >= today) rows.push(row);
        }
        if (page * 20 >= total) return rows;
      }
      throw new Error('Delivery search limit exceeded');
    })
  );
  const rows = groups.flat();
  if (new Set(rows.map((row) => row._id)).size !== rows.length)
    throw new Error('Changed deliveries');
  return rows
    .sort(
      (a, b) =>
        calendarDay(a.deliveryDate).localeCompare(calendarDay(b.deliveryDate)) ||
        a.orderId.localeCompare(b.orderId)
    )
    .slice(0, 3);
}
